import React, {Fragment, memo, useContext, FunctionComponent} from 'react';
import './CartItemReadonly.less';
import {QuantityBadge} from 'elements/quantity-badge/QuantityBadge';
import {CartItemShort} from 'compositions/cart-item-short/CartItemShort.tsx';
import {CartModifier} from 'compositions/cart-modifier/CartModifier.tsx';
import {getSelectedModifiersFromGroup} from 'helpers/modifier.helper';
import {TranslationsContext} from 'contexts/translations-context';
import {getSafeTranslation} from 'helpers/localization.helper.ts';
import {getMenuEntryTotalPrice} from 'helpers/order-line.helper.ts';
import {ModifierGroup, MenuEntryModifierSelections} from 'helpers/modifier.helper.types.ts';

interface CartItemReadonlyProps {
	quantity: number,
	name: string,
	price: number,
	modifierGroups: Array<ModifierGroup>,
	modifierSelections: MenuEntryModifierSelections,
	vatSum: string,
	vatPercent: string
}

export const CartItemReadonly: FunctionComponent<CartItemReadonlyProps> = memo(({quantity, name, price, modifierGroups = [], modifierSelections = {}, vatSum, vatPercent}) => {

	const translations = useContext(TranslationsContext);

	return (
		<div className={`cart-item-readonly`}>
      <span className="cart-item-readonly__quantity">
        <QuantityBadge quantity={quantity}/>
      </span>
			<div className="cart-item-readonly__container">
				<div className="cart-item-readonly__title">
					<CartItemShort name={name}
												 price={getMenuEntryTotalPrice(price, quantity, modifierGroups, modifierSelections)}/>
				</div>
				{modifierGroups.length > 0 && (
					<ul className="cart-item-readonly__modifier-list">
						{modifierGroups.map(modifierGroup => (
							<Fragment key={modifierGroup.modifierGroupId}>
								{getSelectedModifiersFromGroup(modifierGroup, modifierSelections[modifierGroup.modifierGroupId]).map(modifier => {
									const modifierSelection = modifierSelections[modifierGroup.modifierGroupId]
										.find(modifierSelection => modifierSelection.modifierId === modifier.modifierId);
									return (
										<li className="cart-item-readonly__modifier" key={`modifier-${modifier.modifierId}`}>
											<CartModifier name={
												modifierGroup.allowToChangeQuantity && modifierSelection.quantity > 1 ?
													`${modifierSelection.quantity} x ${modifier.name}`
													: modifier.name
											}/>
										</li>
									);
								})}
							</Fragment>
						))}
						{
							typeof vatSum === 'number' && (<li className="cart-item-readonly__modifier" key={`vat-sum`}>
								<CartModifier
									name={
										getSafeTranslation('CartItemReadonly.vatLabel', translations)
											.replace('{percent}', vatPercent.replace('%', ''))
									}
									price={vatSum}
								/>
							</li>)
						}
					</ul>
				)}
			</div>
		</div>
	);
});
